import { FC } from "react";

import { DynamicInputProps } from "../types";


const YesNoInput: FC<DynamicInputProps> = ({ name, label, data_required, render_condition, display, value, isHidden, id, group, state, updateValue }): JSX.Element => {
  return display ? (
    <div className={`row py-3 ${render_condition !== "" ? "bg-light" : ""} ${isHidden ? "d-none" : ""}`}>
      <label htmlFor={`precert[${name}]`} className="col-sm-6 form-label precert-form-label">
        {label} {data_required ? "*" : ""}
      </label>
      <div className="col-sm-6">
        {["No", "Yes"].map((answer, index) => (
          <div className="form-check form-check-inline" key={index}>
            <input
              className="form-check-input"
              type="radio"
              name={name}
              id={`${name}${index}`}
              required={data_required}
              checked={state[name] === answer.trim()}
              onChange={(e) => {
                if (e.target.checked)
                  updateValue(answer.trim(), id, group);
              }}
              defaultChecked={answer.trim() === value}
            />
            <label className="form-check-label" htmlFor={`${name}${index}`}>
              {answer}
            </label>
          </div>
        ))}
      </div>
    </div>
  )
  : <></>
}

export default YesNoInput;
